/**
 * 计算订单费用（税额固定为 0）
 * @param {Array} cartItems 购物车商品列表
 * @returns {{itemsPrice: string, shippingPrice: number, taxPrice: number, totalPrice: string}}
 */
export const caluclateOrderCost = (cartItems) => {
  const itemsPrice = cartItems?.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const shippingPrice = itemsPrice > 200 ? 0 : 25;
  const taxPrice = 0;
  const totalPrice = (itemsPrice + shippingPrice + taxPrice).toFixed(2);

  return {
    itemsPrice: Number(itemsPrice).toFixed(2),
    shippingPrice,
    taxPrice,
    totalPrice,
  };
};
